// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @ utilities
const usd = require('utilities/usd');

// @constants
const DEFAULT_URL = '/myprofile/global';
const { URL_WITH_PROTOCOL_REGEX, URL_WITHOUT_PROTOCOL_REGEX } = require('constants/contactCenter/regex');

class RedirectToContactCenterView extends React.Component {
    componentDidMount() {
        const url = usd.getRedirectURL();

        let contactCenterURL;

        if (!url) {
            contactCenterURL = DEFAULT_URL;
        } else {
            contactCenterURL = this.extractContactCenterURL(url);

            if (!contactCenterURL) {
                contactCenterURL = DEFAULT_URL;
            }
        }

        this.props.history.push(contactCenterURL);
    }

    extractContactCenterURL(url) {
        const result1 = url.match(URL_WITH_PROTOCOL_REGEX);

        if (result1) {
            return (url === result1[0]) ? result1[1] : null;
        }

        const result2 = url.match(URL_WITHOUT_PROTOCOL_REGEX);

        if (result2) {
            return (url === result2[0]) ? result2[1] : null;
        }

        return null;
    }

    render() {
        return (<noscript/>);
    }
}

RedirectToContactCenterView.propTypes = {
  history: PropTypes.object.isRequired
};

module.exports.RedirectToContactCenterView = withRouter(RedirectToContactCenterView);
